<template>
  <v-card>
    <v-toolbar
      color="light-blue"
      elevation="0"
    >
      <v-toolbar-title>
        Your Radar
      </v-toolbar-title>
      <div class="flex-grow-1"></div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="refresh()" v-on="on"><v-icon>refresh</v-icon></v-btn>
        </template>
        <span>Refresh Radar</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col>
          <v-card flat style="overflow-y: auto; overflow-x: hidden; height: 600px; background-color: #F5F5F5;">
            <Favorite
              v-for="(item, index) in favorites"
              :serialNumber="item.serialNumber"
              :version="item.version.semantic"
              :pendingDownload="item.pendingSoftwareDownload"
              :specs="item.specs"
              :specsExpiration="item.specsExpiration"
              :connected="item.connected"
              :favorite="item.favorite"
              :openSupportTickets="item.openSupportTickets"
              :port="item.port"
              :address="item.address"
              :connectionCount="item.connectCount"
              :currentProcedure="item.currentProcedure"
              :alignmentCount="item.alignmentCount"
              :geolocation="item.geolocation"
              :updateState="item.updateState"
              :family="item.family"
              @onRemoveFavorite="removeFavorite"
            >
            </Favorite>
            <div
              v-if="favorites.length === 0"
              class="pa-3"
              style="background-color: black; color: white; text-align: center;"
            >
              NO FAVORITES ON RADAR
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Favorite from '../components/radar/Favorite.vue';

export default {
  components: {
    Favorite,
  },

  data() {
    return {
      busy: false,
    };
  },

  computed: {
    favorites() {
      return this.$store.state.favorites;
    },
  },

  methods: {
    removeFavorite(serialNumber) {
      const options = {
        method: 'post',
        url: '/delete/favorite/v1/',
        data: {
          username: this.$store.state.auth.token.user.username,
          serialNumber,
        },
      };

      this.axios(options);
    },

    refresh() {
      this.$store.dispatch('getFavorites');
    },
  },
};
</script>

<style scoped>
</style>
